import { Directive, HostListener, OnInit } from "@angular/core";
import { NgSelectComponent } from "@ng-select/ng-select";

@Directive({
  selector: "ng-select:not([searchable])",
})
export class NgSelectMobileSearchableDirective implements OnInit {
  constructor(private ngSelect: NgSelectComponent) {}

  ngOnInit(): void {
    this.applySearchableState();
  }

  @HostListener("window:resize")
  onWindowResize(): void {
    this.applySearchableState();
  }

  private applySearchableState(): void {
    if (typeof window === "undefined") return;
    this.ngSelect.searchable = window.innerWidth > 768;
  }
}
